module.exports = __webpack_public_path__ + "img/appxz.7fe90f4b.png";